import React from 'react';
import LogoutButton from '../components/LogoutButton';
import './PanelSocio.css';
import { useNavigate } from 'react-router-dom';

function PanelAdmin() {
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  const navigate = useNavigate();

  const handleNavigation = (url) => {
    try {
      navigate(url);
    } catch (error) {
      window.location.href = url;
    }
  };

  return (
    <div className="panel-socio-bg">
      <div className="panel-socio-card" style={{maxWidth: 700, width: '100%'}}>
        <h2 className="panel-socio-title">👑 Panel del Administrador</h2>
        <div style={{textAlign: 'center', marginBottom: 24}}>
          <div style={{fontSize: '1.2rem', color: '#222', fontWeight: 500}}>
            ¡Bienvenido, <span style={{color: '#D32F2F'}}>{usuario.nombreCompleto}</span>!
          </div>
          <div style={{fontSize: '1rem', color: '#555', marginTop: 4}}>
            Número de Socio: <b>{usuario.numeroSocio}</b>
          </div>
        </div>
        <div className="admin-cards-container">
          <div className="admin-card" onClick={() => handleNavigation('/admin/editar')}>
            <span className="admin-card-icon">📝</span>
            <span className="admin-card-title">Editar mi perfil</span>
          </div>
          <div className="admin-card" onClick={() => handleNavigation('/admin/alta')}>
            <span className="admin-card-icon">➕</span>
            <span className="admin-card-title">Alta de Socio</span>
          </div>
          <div className="admin-card" onClick={() => handleNavigation('/admin/buscar-socios')}>
            <span className="admin-card-icon">🔍</span>
            <span className="admin-card-title">Buscador de Socios</span>
          </div>
          <div className="admin-card" onClick={() => handleNavigation('/admin/buscar-historial')}>
            <span className="admin-card-icon">📜</span>
            <span className="admin-card-title">Buscador de Historial</span>
          </div>
          <div className="admin-card" onClick={() => handleNavigation('/admin/carga-masiva')}>
            <span className="admin-card-icon">📊</span>
            <span className="admin-card-title">Carga Masiva de Socios</span>
          </div>
        </div>
        <button className="btn-panel-socio btn-cerrar-sesion" style={{marginTop: 32}} onClick={() => {
          localStorage.removeItem('token');
          localStorage.removeItem('usuario');
          navigate('/login');
        }}>
          🚪 Cerrar sesión
        </button>
        <div style={{
          marginTop: '24px',
          fontSize: '0.75rem',
          color: '#666',
          textAlign: 'right',
          fontStyle: 'italic'
        }}>
          Licenciado por Ing. Javier Barrios para uso exclusivo de Club Sportivo Miramar Misiones
        </div>
      </div>
    </div>
  );
}

export default PanelAdmin; 